import { useState, useRef } from "react";
import { ChevronDown } from "lucide-react";
import { motion, AnimatePresence, ease as mmEase, useInView } from "@/lib/motion";
import { FAQS } from "../data";

const ez = mmEase.expo;

export default function FaqSection() {
  const [open, setOpen] = useState(null);
  const ref    = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px 0px" });

  return (
    <section id="pricing" ref={ref} className="py-24 px-6" style={{ background: "var(--color-section-cream)" }}>
      <div className="max-w-[800px] mx-auto">

        <motion.div
          initial={{ opacity: 0, y: 14 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.55, ease: ez }}
          className="mb-12"
        >
          <p className="text-[10px] font-bold uppercase tracking-[0.22em] text-emerald mb-3">
            Common questions
          </p>
          <h2
            className="font-display font-black text-navy"
            style={{ fontSize: "clamp(1.6rem, 3.2vw, 2.5rem)", letterSpacing: "-0.032em" }}
          >
            Everything you need to know.
          </h2>
        </motion.div>

        <div className="space-y-2">
          {FAQS.map((faq, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 10 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.44, ease: ez, delay: i * 0.05 }}
              className="rounded-2xl overflow-hidden"
              style={{ border: "1px solid rgba(11,29,58,0.08)" }}
            >
              <button
                data-testid={`faq-${i}`}
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-4 text-left hover:bg-[var(--color-section-subtle)] transition-colors"
              >
                <span className="font-semibold text-navy text-[15px] pr-4">{faq.q}</span>
                <motion.div
                  animate={{ rotate: open === i ? 180 : 0 }}
                  transition={{ duration: 0.24, ease: ez }}
                  className="shrink-0"
                >
                  <ChevronDown size={16} style={{ color: "rgba(11,29,58,0.35)" }} />
                </motion.div>
              </button>
              <AnimatePresence initial={false}>
                {open === i && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{    height: 0, opacity: 0 }}
                    transition={{ duration: 0.28, ease: ez }}
                    style={{ overflow: "hidden" }}
                  >
                    <p
                      className="px-6 pt-4 pb-5 text-[14px] leading-relaxed"
                      style={{
                        color: "rgba(11,29,58,0.54)",
                        borderTop: "1px solid rgba(11,29,58,0.06)",
                      }}
                    >
                      {faq.a}
                    </p>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
}
